import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/Floor");
}

const GetByKey = (id) => {
  return apiClient
    .get("/Floor/GetByKey", {
      params: {
        'Id': id
      }
    });
}

const FloorDropDown = (hotelId) => {
  return apiClient
    .get("/Floor/FloorDropDown", {
      params: {
        'HotelId': hotelId
      }
    });
}

const GetForUser = () => {
  return apiClient
    .get("/Floor/GetForUser");
}
const SoftDelete = (id) => {
  return apiClient
    .delete("/Floor", {
      params: {
        'Id': id
      }
    });
}
const Add = (data, hotelStructureId) => {
  return apiClient.post('/Floor', {
    'number': data.number,
    'name': data.name,
    'description': data.description,
    'hotelStructureId': hotelStructureId
  }
  )
}
const Update = (id, data) => {
  return apiClient.put('/Floor', {
    'id': id,
  }
  )
}

const AutoDesignFloor = (data, hotelStructureId) => {
  return apiClient.post('/Floor/AutoDesignFloor', {
    "number": data.number,
    "name": data.name,
    "description": data.description,
    "hotelStructureId": hotelStructureId,
    "roomCount": data.roomCount,
    "bedCount": data.bedCount
  }
  )
}

const floorApi = { Add, Update, GetAll, GetByKey, FloorDropDown, GetForUser, SoftDelete, AutoDesignFloor }
export default floorApi;